import type { ResolvedCollection } from '@rstore/shared';

export function hasCompositeKey(collection: ResolvedCollection) {
	return (collection.meta?.primaryKeyFields?.length ?? 0) > 1;
}
